import React from 'react'
import { navigateToSearchByApp, navigateToPoisOnRouteByApp } from '../../store/history/history.actions'
import { TAG_CLICK_CATEGORY_BAR } from '../analytics/analytics.tagids.constants'
import { APP_OR_SUBCAT_ID, CAT_ID } from '../analytics/ClickTagsService'
import useConfigureAndSendTag from '../analytics/useConfigureAndSendTag'
import { useAction } from '../utils/react-redux'
import s from './MenuSubCategoryItem.less'
import { itemClassName } from './CategorySubMenuStyle'
import classnames from 'classnames'
import { selectIsPageElligibleForPoisOnRoute } from '../../store/history/history.selectors'
import { useSelector } from 'react-redux'

const MenuApplicationItem = ({ id, logo, name, categoryId, onClick }) => {
  const execNavigateToSmrByApp = useAction(navigateToPoisOnRouteByApp)
  const configureAndSendTag = useConfigureAndSendTag()
  const execNavigateToSearchByApp = useAction(navigateToSearchByApp)

  const isPageElligibleForPoisOnRoute = useSelector(selectIsPageElligibleForPoisOnRoute)

  const onApplicationClick = (categoryId, appId) => e => {
    configureAndSendTag({
      type: TAG_CLICK_CATEGORY_BAR,
      tagInfo: {
        [CAT_ID]: categoryId,
        [APP_OR_SUBCAT_ID]: appId
      }
    })

    if (isPageElligibleForPoisOnRoute) {
      execNavigateToSmrByApp(id)
    } else {
      execNavigateToSearchByApp(appId)
    }
    onClick()
  }

  return (
    <li className={classnames(s.root, itemClassName)} onClick={onApplicationClick(categoryId, id)}>
      <span className={s.logoWrapper}>
        <img src={logo} className={s.logo} />
      </span>
      <span className={s.label}>{name}</span>
    </li>
  )
}

export default MenuApplicationItem
